import React from 'react';
import { Link } from 'react-router-dom';
import { states } from '../data/mock';

const StatesCoverage = () => {
  return (
    <section className="py-16 bg-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-2">
            We Serve All <span className="text-orange-500">50 States</span>
          </h2>
          <p className="text-gray-400">Click on your state to learn more about our local services</p>
        </div>

        {/* States Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-x-8 gap-y-2">
          {states.map((column, colIndex) => (
            <div key={colIndex} className="space-y-2">
              {column.map((state) => (
                <Link
                  key={state}
                  to={`/locations/${state.toLowerCase().replace(/\s+/g, '-')}`}
                  className="block text-gray-400 hover:text-orange-400 transition-colors text-sm py-1"
                >
                  {state}
                </Link>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatesCoverage;